




































































import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import {searchBillLading} from "@/modules/searchbilllading/service";
import debounce from "lodash/debounce";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

@Component({
    name: "SearchBillContent",
    components: {AInputBarCode}
})
export default class extends mixins(CommonMixin) {
    @Prop({ default: '40px' }) readonly fontSize!: string;
    @PropSync('ladingCode') syncLadingCode!: string;
    @PropSync('billLadings') syncBillLadings!: any;
    @PropSync('siteNote') syncSiteNote!: any;
    @Prop({ default: false }) readonly isFull!: boolean;

    columns = [
        {
            title: "Số vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            align: "center",
            width: 120,
            ellipsis: true
        },
        {
            title: "Bưu cục phát",
            dataIndex: "deliveryPostOfficeSuggest.name",
            key: "deliveryPostOfficeName",
            scopedSlots: {customRender: "deliveryPostOffice"},
            align: "center",
            width: 250,
            ellipsis: true
        },
        {
            title: "Tuyến phát",
            dataIndex: "rowGuid",
            key: "deliveryEmployeeName",
            scopedSlots: {customRender: "deliveryEmployee"},
            align: "center",
            width: 400,
            ellipsis: true
        }
    ];

    get billLading() {
        return this.getProp(this.syncBillLadings, '[0]', null);
    }

    async onSearchChange(evt: any) {
        const val = evt?.target?.value;
        if (!val || val.isEmpty) return;
        this.handleChange(val, this);
    }

    handleChange = debounce(async (val, vm) => {
        try {
            const {data} = await searchBillLading(val)
            const assignObject = Object.assign({stt: 1}, data.data.billLading)
            vm.syncBillLadings.splice(0, vm.syncBillLadings.length);
            vm.syncBillLadings.push(assignObject);
            vm.syncSiteNote = data.data.site.note
        } catch (e) {
            vm.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        } finally {
            vm.syncLadingCode = undefined;
        }
    }, 500);

    clearBillLading() {
        this.syncBillLadings = [];
        this.syncLadingCode = "";
    }
}
